export default list => list ? list[0] : undefined
